module.exports = __webpack_public_path__ + "img/logo-branco.3aa29afc.png";